module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._b({}, 'el-dialog', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87ec05dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dialog/rtDialog.vue
// module id = 1459
// module chunks = 116